import { createContext, useContext } from 'react';

const AdminPersistContext = createContext(null);

export function AdminPersistProvider({ value, children }) {
  return <AdminPersistContext.Provider value={value}>{children}</AdminPersistContext.Provider>;
}

export function useAdminPersist() {
  const ctx = useContext(AdminPersistContext);
  if (!ctx) {
    throw new Error('useAdminPersist must be used inside AdminPersistProvider');
  }
  return ctx;
}
